import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dsf_title"]

import router, { DEFAULT_ROUTE } from '@/router'
import AppNavigationItems from './AppNavigationItems.vue'
import ProfileMenu from './AppLayoutHeader/components/ProfileMenu.vue'
import { analytics } from '@/services/analyticsProvider'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMobileSidebar',
  props: {
  opened: Boolean,
},
  emits: ['close'],
  setup(__props, { emit }) {





function closeMobileSidebar() {
  emit('close')
}

const navigate = (e: CustomEvent) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
  closeMobileSidebar()
}

function handleLogoClick() {
  analytics.trackShellEvent('click/icon-shipper-portal')
  router.push({ path: DEFAULT_ROUTE })
  closeMobileSidebar()
}

return (_ctx: any,_cache: any) => {
  return (__props.opened)
    ? (_openBlock(), _createElementBlock("dsf-navbar", {
        key: 0,
        id: "mobileNav",
        dsf_mobile: "",
        dsf_title: _ctx.$t('navigation.title.expanded'),
        onNavigate: navigate,
        onClose: closeMobileSidebar,
        onLogoClick: handleLogoClick
      }, [
        _createCommentVNode(" Page navigation items "),
        _createVNode(AppNavigationItems),
        _createCommentVNode(" Profile menu items "),
        _createVNode(ProfileMenu, {
          slot: "footer",
          "mobile-mode": true,
          onClose: _cache[0] || (_cache[0] = (event) => event.stopPropagation()),
          onSelectLanguage: closeMobileSidebar,
          class: "mt-auto"
        })
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}
}

})